module.exports = __webpack_public_path__ + "img/empty_box2.6eb4c9b2.png";